import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import CustomButton from "../../components/customButton";
import { BookCopy, FunnelX } from "lucide-react";
import AnnouncementCard from "../../components/card/announcementCard";
import { useNavigate } from "react-router-dom";
import {
  getAllNotifications,
  resendNotification,
} from "../../services/Notification";
import { openSnackAlert } from "../../helper";
import AppLoader from "../../components/appLoader";

const Announcements = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await getAllNotifications();
      if (response?.status === 200 || response?.status === 201) {
        setNotifications(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      openSnackAlert("Error loading notifications", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async (id) => {
    try {
      setLoading(true);
      const response = await resendNotification(id);
      if (response?.status === 200 || response?.status === 201) {
        openSnackAlert("Notification resended successfully", "success");
        fetchNotifications();
      } else {
        openSnackAlert(response?.message || "Something went wrong", "error");
      }
    } catch (error) {
      openSnackAlert(error?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-announcement/${id}`);
  };

  return (
    <>
      <Box
        bgcolor="primary.bgLight"
        padding={"20px"}
        borderRadius={"22px"}
        mt={0}
      >
        <AppLoader isVisible={loading} />
        <Grid container spacing={2}>
          <Grid item sm={12} md={5}>
            <Typography variant="h4">Announcements/Notifications</Typography>
            <Typography variant="description">Keep Team Update</Typography>
          </Grid>
          <Grid item sm={12} md={7}>
            <Box display={"flex"} justifyContent={"flex-end"} gap={1.5}>
              <CustomButton
                btnLabel={"Add Form"}
                variant={"webbutton"}
                btnTextSize={10}
                startIcon={<BookCopy size={14} strokeWidth={2} />}
                handlePressBtn={() => {
                  navigate("/add-announcement");
                }}
              />
              {/* <CustomButton
                btnLabel={"Filter"}
                variant={"outlinebutton"}
                btnTextSize={10}
                btnTextColor={"#225B27"}
                startIcon={
                  <FunnelX color="#000" strokeWidth={1.75} size={16} />
                }
              /> */}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} mt={1}>
          {notifications.length > 0 ? (
            notifications.map((notification, idx) => (
              <Grid item xs={12} sm={6} md={3} key={notification._id || idx}>
                <AnnouncementCard
                  {...notification}
                  onEdit={handleEdit}
                  onResend={handleResend}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography>
                No notifications found. Create your first announcement!
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default Announcements;
